import React, { FC } from "react";
import { Loader } from "@progress/kendo-react-indicators";
const types = ["pulsing", "infinite-spinner", "converging-spinner"];

export const OverLayLoading: FC<{ show?: boolean }> = ({ show }) => {
	return (
		<div
			className="overlay"
			style={{
				display: show ? "flex" : "none",
				justifyContent: "center",
				alignItems: "center",
				margin: "auto",
			}}
		>
			<Loader size="large" type={"pulsing"} />
		</div>
	);
};

export const Loading: FC<{ show?: boolean }> = ({ show }) => {
	return (
		<div
			style={{
				display: show ? "flex" : "none",
				justifyContent: "center",
				alignItems: "center",
				margin: "auto",
			}}
		>
			<Loader size="large" type={"pulsing"} />
		</div>
	);
};

export default Loading;
